export default __webpack_public_path__ + "static/media/admin.a6143582.png";